import React from 'react'
import type { FC } from 'react'

interface LogoProps {
  [key: string]: any
  style?: React.CSSProperties
}

const Logo: FC<LogoProps> = (props) => <img style={props?.style || {}} alt="Logo" height={50} src="/static/images/link-logo-white.svg" {...props} />

export default Logo
